// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import colors from '../../assets/css/colors';
import RoundSelectorItem from './RoundSelectorItem';

const RoundSelectorWrapper = styled.div`
	position: relative;
	box-shadow: 0px 3px 10px 0px rgba(0,58,49,0.30);
	&:after{
		top: 100%;
		left: 50%;
		border: solid rgba(246, 246, 246, 0);
		content: " ";
		height: 0;
		width: 0;
		position: absolute;
		pointer-events: none;
		border-top-color: ${colors.lightGrey};
		border-width: 11px 6px 0 6px;
		margin-left: -6px;
	}

`;
const RoundSelectorContent = styled.div`
overflow-x: scroll;
	overflow-y: hidden;
	display: flex;
	flex-wrap: nowrap;
	background: ${colors.lightGrey};
	height: 30px;
	width: auto;
	&::-webkit-scrollbar{
		display: none;
	}
`;

type Props = {
	selected?: ?number,
	rounds: Array<Object>,
	round_aliases?: Object,
	handleClick: Function
}

export const RoundSelector = ({ selected, rounds, round_aliases = {}, handleClick }: Props) => {
	const selected_index = _.findIndex(rounds, function(r) {
		return r.id === selected;
	});
	const first_round = _.first(rounds);

	if (_.isEmpty(rounds)) {
		return null;
	}
	return (
		<RoundSelectorWrapper>
			<RoundSelectorContent>
				{rounds.map(round => (
					<RoundSelectorItem
						round_status={round.status}
						key={round.id}
						is_first={first_round.id === round.id}
						selected_round_index={selected_index}
						round_number={round.id}
						selected_round={selected}
						round_alias={round_aliases[round.id]}
						handleClick={handleClick}
					/>
				))}
			</RoundSelectorContent>
		</RoundSelectorWrapper>
	);
};

export default RoundSelector;


// WEBPACK FOOTER //
// ./src/components/RoundSelector/index.js